export interface TabItem {
  id: string;
  label: string;
  count?: number;
  warn?: boolean;
}

export function Tabs({
  items,
  active,
  onChange,
}: {
  items: TabItem[];
  active: string;
  onChange: (id: string) => void;
}) {
  return (
    <div
      role="tablist"
      style={{ display: 'flex', gap: 16, borderBottom: '1px solid var(--border)' }}
    >
      {items.map((t) => {
        const on = t.id === active;
        return (
          <button
            key={t.id}
            role="tab"
            aria-selected={on}
            onClick={() => onChange(t.id)}
            style={{
              height: 36,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              padding: 0,
              font: '500 14px/20px var(--font-ui)',
              color: on ? 'var(--text)' : 'var(--dim)',
              boxShadow: on ? `inset 0 -2px 0 ${t.warn ? 'var(--warn)' : 'var(--accent)'}` : 'none',
            }}
          >
            {t.label}
            {t.count !== undefined && t.count > 0 && (
              <span
                style={{
                  height: 18,
                  minWidth: 18,
                  padding: '0 5px',
                  borderRadius: 'var(--r-full)',
                  textAlign: 'center',
                  font: '600 12px/18px var(--font-ui)',
                  background: t.warn ? 'var(--warn)' : 'var(--neutral-soft)',
                  color: t.warn ? 'var(--badge-ink)' : 'var(--dim)',
                }}
              >
                {t.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
